
import api from '@/plugins/api'
import eventBus from '../../plugins/eventBus'
import { Component, Vue } from 'vue-property-decorator'
import CreditModal from '@/modules/credits/CreditModal.vue'

@Component({
  components: { CreditModal },
})
export default class CreditsHistory extends Vue {
  details: Array<Object> = []
  credits: Array<Object> = []

  openCreditDetails(index: number) {
    this.$modal.show('credits-details')
  }

  getTransferedCredits() {
    api()
      .get('me/transfer-credits')
      .then((response: any) => {
        this.credits = response.data.data
      })
  }

  mounted() {
    this.getTransferedCredits()

    eventBus.$on('credits:transfered', () => {
      this.getTransferedCredits()
    })
  }
}
